// AUTO-GENERATED by scripts/sync-meta.cjs. Do not edit manually.
export const APP_NAME = 'Team Site'
export const APP_VERSION = '0.1.4'
export const APP_AUTHOR = 'X Studios'
export const APP_WEBSITE_URL = 'https://xstudios.com'
